import React from "react";
import CeoContent from "./CeoContent";
import CeoOrganizationChart from "./CeoOrganizationChart";
import { Seo } from "../../../components/Seo";
import { useTranslation } from "react-i18next";

const Ceo = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={`${t("aboutUs.ceo.seo.title")}`} description={`${t("aboutUs.ceo.seo.des")}`} path="about/organization" />
      <CeoContent />
      <CeoOrganizationChart />
    </>
  );
};

export default Ceo;
